import type { IDataViewHeaderConfig } from '@/domains/investor/components/DataView/DataView.types'

export const SIGNIFICANT_TRANSACTIONS_HEADER_CONFIG: IDataViewHeaderConfig = {
  text: '',
}
